import { FAVOURITES_RECEIVE,
    FAVOURITES_TOGGLE } from '../Actions/Favourites.action';
export const favouritesdata = (state = {}, action) => {
    switch (action.type) {
        case FAVOURITES_TOGGLE:
            return {
                ...state,
                payload: state.payload.map(f => {
                    if(f.variantSystemId == action.payload.variantSystemId){
                        return {
                            ...f,
                            isFavourite: !f.isFavourite
                        }
                    }

                    return f;
                })
            }
        case FAVOURITES_RECEIVE:
            return {
                ...state,
                payload: state.payload.map(fav => {
                                        if (fav.variantSystemId == action.payload.favouritesdata.variantSystemId) {
                        fav.isFavourite = !action.payload.favouritesdata.isFavourite;
                    }
                    return fav;
                })
            };
        default:
            return state;
    }
}